export default function isUpgrade(pathname) {
  return pathname?.includes('/upgrade/') || pathname?.includes('/transfer/');
}
